var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKosher({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#0e111d;fill-rule:evenodd}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8 0C3.58 0 0 3.58 0 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8Zm.02 15.02c-3.87 0-7-3.13-7-7s3.14-7 7-7 7 3.13 7 7-3.13 7-7 7Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.65 9.52s-.13 1.58-1.67 1.58-1.6-1.58-1.6-1.58V4.66H4.8l.05 4.99s-.08 2.68 3.13 2.68 3.22-2.68 3.22-2.68V4.66H9.65v4.85Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKosher);
export default __webpack_public_path__ + "static/media/kosher.c94e5f209e3348031c252781ffc7a061.svg";
export { ForwardRef as ReactComponent };